<!-- 
dropdown
 -->
<script>
export default {
  name: 'dropdown',
  props: {
    items: {

    },
    label: {},
    labelName: {
      default: 'label'
    },
    value: {
      default: false
    },
    valueName: {
      default: 'value'
    },
    dropUp: {},
    size: {},
    justified: {},
  },
  render(h) {
    var self = this
    var children = []
    var dropdownBtn = h('btn', {
      ref: 'dropdown-toggle',
      attrs: { 'data-toggle': 'dropdown' },
      class: [
        'dropdown-toggle',
        { 'w-100': this.justified },
        { 'btn-sm': this.size == "sm" },
      ],
      props: { btnClass: 'secondary' }
    }, [this.labelText])
    children.push(dropdownBtn)
    if (this.$slots.default) {
      children.push(this.$slots.default)
    }
    var dropdownItems = []
    dropdownItems.push(this.$slots.prepend_list)
    if (this.items) dropdownItems.push(
      this.items.map((item) => {
        if (_.isObject(item)) {
          var label = item[this.labelName]
          var value = item[this.valueName]
        } else {
          label = item
          value = item
        }
        return h('a', {
          class: [
            'dropdown-item',
            this.value == value ? 'active' : ''
          ],
          domProps: {
            innerHTML: label
          },
          attrs: { 'data-value': value },
          on: { click: self.selectItem }
        })
      })
    )
    dropdownItems.push(this.$slots.list)
    var dropdownMenu = h('div', { class: 'dropdown-menu' }, dropdownItems)
    children.push(dropdownMenu)

    return h('div', {
      class: [
        'btn-group',
        { 'w-100': this.justified },
        this.dropUp ? 'dropup' : 'dropdown'
      ]
    }, children)
  },
  mounted() {
    $(this.dropdownBtn).dropdown();
  },
  computed: {
    dropdownBtn() {
      return this.$refs['dropdown-toggle'].$el
    },
    labelText() {
      if (this.items && this.value!=null && _.isObject(this.items[0])) return _.find(this.items, (item) => { return item[this.valueName] == this.value })[this.labelName]
      return this.value != null ? this.value : this.label
    }
  },
  methods: {
    selectItem(event) {
      var value = $(event.target).data('value')
      this.$emit('input', value)
    },
    toggleDropdown() {
      console.log('toggleDropdown')
      $(this.dropdownBtn).dropdown('toggle')

    }
  }
}

</script>
